import * as yup from "yup";

export default yup.object().shape({
  gender: yup.string().required("Required"),
  race: yup.array().min(1, "Required").required("Required"),
  ethnicity: yup.string().required("Required"),
  militaryStatus: yup.mixed().nullable().test("military-required", "Required", (v) => v === true || v === false),

  countryOfBirth: yup.string().required("Required"),
  stateOfBirth: yup.string().when("countryOfBirth", {
    is: (v) =>
      (typeof v === "string" && v === "United States") ||
      (v && typeof v === "object" && v.countryName === "United States"),
    then: (schema) => schema.required("Required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  livesWith: yup.string().required("Required"),

  streetAddress: yup.string().required("Required"),
  addressLine2: yup.string().nullable(),
  city: yup.string().required("Required"),
  state: yup.string().required("Required"),
  zipCode: yup.string().required("Required"),

  parent1: yup.object().shape({
    firstName: yup.string().required("Required"),
    lastName: yup.string().required("Required"),
    phoneType: yup.string().required("Required"),
    phoneNumber: yup.string().required("Required"),
    email: yup
      .string()
      .email("Invalid email")
      .required("Required"),
  }),
  schoolName: yup.string().required("Required"),
  hasInsurance: yup.string().required("Required"),
  insuranceProvider: yup.string().when("hasInsurance", {
    is: "yes",
    then: (schema) => schema.required("Required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  giftedProgram: yup.string().required("Required"),
  specialEducation: yup.string().required("Required"),
  languagesAtHome: yup.string().required("Required"),
  surveryQuestion1: yup.string().required("Required"),
  surveryQuestion2: yup.string().required("Required"),
  surveryQuestion3: yup.string().required("Required"),
  surveryQuestion4: yup.string().required("Required"),
  releaseOfInformation: yup
    .string()
    .nullable()
    .when(["recordsRelease", "$activeStep"], {
      is: (recordsRelease, activeStep) =>
        activeStep === 5 && recordsRelease === "yes",
      then: (schema) => schema.required("Signature is required"),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),

});
